import { render, staticRenderFns } from "./TakeQuiz.vue?vue&type=template&id=73d86c59&scoped=true&"
import script from "./TakeQuiz.vue?vue&type=script&lang=js&"
export * from "./TakeQuiz.vue?vue&type=script&lang=js&"
import style0 from "./TakeQuiz.vue?vue&type=style&index=0&id=73d86c59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d86c59",
  null
  
)

export default component.exports